<script>
    import {queryString} from '../../mixins/querystring'

    export default {
        mixins: [queryString],
        props: ['sources'],
        data() {
            return {
                currentButton: null,
                currentDropdown: null,
                filters: {
                    age: null,
                    disabilities: [],
                    modalities: [],
                    countries: ['IT'],
                    months: [],
                    locations: [],
                    languages: []
                },
                appliedFilters: ['countries'],
                ...this.sources
            }
        },
        computed: {
            moreOrEmptyMonth() {
                return _.isEmpty(this.filters.months) || this.filters.months.length > 1
            },
            moreMonths() {
                return this.filters.months.length > 1
            },
            getMoreMonths() {
                const months = [
                    '', 'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
                ]
                const arr = []
                if (this.filters.months.length > 1) {
                    this.filters.months.forEach((m) => {
                        arr.push(months[parseInt(m,10)])
                    })
                }

                return arr.join(', ')
            },
            getMonthName() {
                if (this.filters.months.length > 0) {
                    let monthIdx = this.filters.months[0]
                    return moment().month(monthIdx - 1).format('MMMM')
                }
                return null
            },
            moreOrEmptyModality() {
                return _.isEmpty(this.filters.modalities) || this.filters.modalities.length > 1
            },
            moreModalities() {
                return this.filters.modalities.length > 1
            },
            getModalityName() {
                if (this.filters.modalities.length > 0) {
                    let modalityId = this.filters.modalities[0]
                    return this.modalities.filter(i => i.id == modalityId)[0].name
                }
                return null
            },
            getMoreModalities() {
                const arr = []
                if (this.filters.modalities.length > 1) {
                    this.filters.modalities.forEach((m) => {
                        arr.push(this.modalities.filter(i => i.id == m)[0].name)
                    })
                }

                return arr.join('<br />')
            },
            moreOrEmptyLocation() {
                return _.isEmpty(this.filters.locations) || this.filters.locations.length > 1
            },
            moreLocations() {
                return this.filters.locations.length > 1
            },
            getLocationName() {
                if (this.filters.locations.length > 0) {
                    return _.head(this.filters.locations)
                }
                return null
            },
            getMoreLocations() {
                const arr = []
                if (this.filters.locations.length > 1) {
                    this.filters.locations.forEach((l) => {
                        
                        arr.push(this.locations.filter(i => i.toLowerCase() == l.toLowerCase())[0])
                    })
                }

                return arr.join(', ')
            },
            moreOrEmptyLanguage() {
                return _.isEmpty(this.filters.languages) || this.filters.languages.length > 1
            },
            moreLanguages() {
                return this.filters.languages.length > 1
            },
            getLanguageName() {
                if (this.filters.languages.length > 0 && this.languages.length > 0) {
                    let languageId = this.filters.languages[0]
                    return _.head(this.languages.filter(i => i.id == languageId)).name
                }
                return null
            },
            getMoreLanguages() {
                const arr = []
                if (this.filters.languages.length > 1) {
                    this.filters.languages.forEach((l) => {
                        arr.push(this.languages.filter(i => i.id == l)[0].name)
                    })
                }

                return arr.join(', ')
            },
            moreOrEmptyCountry() {
                return _.isEmpty(this.filters.countries) || this.filters.countries.length > 1
            },
            moreCountries() {
                return this.filters.countries.length > 1
            },
            getCountryName() {
                if (this.filters.countries.length > 0 && this.countries.length > 0) {
                    let countryCode = this.filters.countries[0].toUpperCase()
                    let country = _.head(this.countries.filter(i => i.code == countryCode))

                    return country.name
                }
                return null
            },
            getMoreCountries() {
                const arr = []
                if (this.filters.countries.length > 1) {
                    this.filters.countries.forEach((c) => {
                        arr.push(this.countries.filter(i => i.code == c.toUpperCase())[0].name)
                    })
                }

                return arr.join(', ')
            },
            moreOrEmptyDisability() {
                return _.isEmpty(this.filters.disabilities) || this.filters.disabilities.length > 1
            },
            moreDisabilities() {
                return this.filters.disabilities.length > 1
            },
            getDisabilityName() {
                if (this.filters.disabilities.length > 0) {
                    let disabilityId = this.filters.disabilities[0]
                    return _.head(this.disabilities.filter(i => i.id == disabilityId)).name
                }
                return null
            },
            getMoreDisabilities() {
                const arr = []
                if (this.filters.disabilities.length > 1) {
                    this.filters.disabilities.forEach((l) => {
                        arr.push(this.disabilities.filter(i => i.id == l)[0].name)
                    })
                }

                return arr.join(', ')
            },
        },
        mounted() {
            console.log()

            this.initData()

            window.addEventListener('mouseup', (e) => {
                let el = document.getElementById(this.currentDropdown)
                if (this.currentDropdown == e.target) {
                    $(el).removeClass('show')
                } else {
                    if (!this.isDescendant(el, e.target)) {
                        $(el).removeClass('show')
                    }
                }
            }, true)

            $('[data-toggle="tooltip"]').tooltip()
        },
        methods: {
            initData() {
                this.updateFormData()
            },
            updateFormData() {
                let params = this.getAllUrlParams()

                console.log(params)

                console.log(this.modalities)
                console.log(this.languages)
                console.log(this.locations)
                console.log(this.countries)
                console.log(this.disabilities)

                for (let prop in params) {
                    if (!_.isEmpty(params[prop]) || !_.isUndefined(params[prop])) {
                        if (this.filters.hasOwnProperty(prop)) {
                            this.$set(this.filters, prop, params[prop])
                            this.appliedFilters.push(prop)
                        }
                    }
                }
            },
            close() {
                $('#summerCampFilters').modal('hide')
            },
            resetAll() {
                for (let filter in this.filters) {
                    if (_.isArray(this.filters[filter])) {
                        this.$set(this.filters, filter, [])
                    } else {
                        this.$set(this.filters, filter, null)
                    }

                    let idx = _.findIndex(this.appliedFilters, i => i == filter)
                    this.appliedFilters.splice(idx, 1)
                }

                this.$emit('update-filters', this.filters)

                this.close()
            },
            onToggleMonth(month) {
                if (! this.filters.months.includes(month.utc)) {
                    this.filters.months.push(month.utc)
                } else {
                    let idx = _.findIndex(this.filters.months, i => i == month.utc)
                    this.filters.months.splice(idx, 1)
                }
            },
            onSelectModality(modality) {
                let idx = this.filters.modalities.indexOf(modality.id)
                if (idx >= 0) {
                    this.filters.modalities.splice(idx, 1)
                } else {
                    this.filters.modalities.push(modality.id)
                }
            },
            isSelectedModality(modality) {
                let selected = false
                this.filters.modalities.forEach(i => {
                    if (parseInt(i) == modality.id) {
                        selected = true
                    }
                })
                return selected
            },
            onSelectLocation(location) {
                let idx = this.filters.locations.indexOf(location)
                if (idx >= 0) {
                    this.filters.locations.splice(idx, 1)
                } else {
                    this.filters.locations.push(location)
                }
            },
            isSelectedLocation(location) {
                return this.filters.locations.indexOf(location) >= 0
            },
            onToggleLanguage(language) {
                if (! this.filters.languages.includes(language.id)) {
                    this.filters.languages.push(language.id)
                } else {
                    let idx = _.findIndex(this.filters.languages, i => i == language.id)
                    this.filters.languages.splice(idx, 1)
                }
            },
            onToggleCountry(country) {
                if (! this.filters.countries.includes(country.code)) {
                    this.filters.countries.push(country.code)
                } else {
                    let idx = _.findIndex(this.filters.countries, i => i == country.code)
                    this.filters.countries.splice(idx, 1)
                }
            },
            onSelectDisability(disability) {
                let idx = _.findIndex(this.filters.disabilities, i => parseInt(i) == disability.id)
                if (idx >= 0) {
                    this.filters.disabilities.splice(idx, 1)
                } else {
                    this.filters.disabilities.push(disability.id)
                }
            },
            isSelectedDisability(disability) {
                let selected = false
                this.filters.disabilities.forEach(i => {
                    if (parseInt(i) == disability.id) {
                        selected = true
                    }
                })
                return selected
            },
            incrementAge() {
                if (_.isNumber(this.filters.age)) {
                    this.filters.age++
                } else {
                    this.filters.age = 1
                }
            },
            decrementAge() {
                if (!_.isNumber(this.filters.age) || this.filters.age == 1) return

                this.filters.age--
            },
            toggleMenu(menuId, e) {
                this.$set(this, 'currentButton', e.target)
                this.$set(this, 'currentDropdown', menuId)
                $(`#${menuId}`).addClass('show')
            },
            isDescendant(parent, child) {
                let node = child.parentNode
                while (node != null) {
                    if (node == parent) {
                        return true
                    }
                    node = node.parentNode
                }
                return false
            },
            applyAll() {
                for (let filter in this.filters) {
                    if (_.isArray(this.filters[filter])) {
                        if (this.filters[filter].length > 0) {
                            this.appliedFilters.push(filter)
                        }
                    } else {
                        if (_.isNumber(this.filters[filter])) {
                            this.appliedFilters.push(filter)
                        }
                    }
                }

                this.$emit('update-filters', this.filters)

                this.close()
            },
            applyFilters(filter) {
                this.appliedFilters.push(filter)

                $(".dropdown-menu").each(function(idx) {
                    $(this).removeClass('show')
                })

                this.$set(this, 'currentButton', null)
                this.$set(this, 'currentDropdown', null)
                this.$emit('update-filters', this.filters)
                this.$bus.$emit('update-filters', this.filters)
            },
            removeFilter(filter) {
                this.$set(this, 'currentButton', null)
                this.$set(this, 'currentDropdown', null)

                if (_.isArray(this.filters[filter])) {
                    this.$set(this.filters, filter, [])
                } else {
                    this.$set(this.filters, filter, null)
                }

                let idx = _.findIndex(this.appliedFilters, i => i == filter)
                this.appliedFilters.splice(idx, 1)

                $(".dropdown-menu").each(function(idx) {
                    $(this).removeClass('show')
                })

                this.$emit('update-filters', this.filters)
            },
            isApplied(filter) {
                return this.appliedFilters.includes(filter)
            }
        }
    }
</script>

<style scoped>
#summerCampFilters .dropdown-item,
.filters__container .dropdown-item {
    padding: 0 5px !important;
}
.custom-tooltip-container{
    position:relative;
}
.custom-tooltip-container:hover .custom-tooltip {
    display:block;
}
.custom-tooltip {
    display:none;
    position: absolute;
    bottom: 40px;
    left: -10px;
    z-index: 20;
    color: #000;
    font-size: 12px;
    width: auto;
    text-align: center;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 5px 10px;
    min-width: 180px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/summer-camps/SummerCampSearchFiltersContainer.vue